import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { environment } from '../../../environments/environment';
import { AuthenticationService } from '../services/authentication.service';

@Injectable()
export class AuthenticationInterceptor implements HttpInterceptor {
  private authentication = inject(AuthenticationService);

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler,
  ): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        if (this.authentication.isErrorResponseUnauthorized(error)) {
          this.authentication.login(window.location.href);
        } else if (this.authentication.isErrorResponseForbidden(error)) {
          window.location.href = environment.selectionToolBaseUrl;
        }
        return throwError(error);
      }),
    );
  }
}
